import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { SevenroomsSeatingArea } from '../../../models/SeatingArea'
import { VENUE_SEATING_AREAS_URL, VENUES_URL } from '../../../utils/urls'

const fetchSevenroomsSeatingAreaForVenue = (venueSlug: string) =>
  SBAPI.Fetch<SevenroomsSeatingArea[]>(
    `${VENUES_URL}/${venueSlug}/integrations/sevenrooms/seating-areas`
  )

/**
 * Attach Seating area to the Venue
 *
 * Attaching seating areas to a venue is actually mapping the Venue's Sevenrooms seating areas to global seating areas
 *
 * @param venueSlug
 * @param seatingAreasAssociation
 * @returns
 */
const attachSeatingAreas = (
  venueSlug: string,
  body: { seatingAreasAssociation: { sevenrooms: string; area: number }[] }
) =>
  SBAPI.Post(
    `${VENUES_URL}/${venueSlug}/integrations/sevenrooms/seating-areas`,
    body
  )

/**
 * Update VenueSeatingArea Booking Visibility
 * @param body
 * @returns
 */
const updateVenueSeatingAreaBookingVisibility = (body: {
  venueSeatingAreas: number[]
  whatsappBookingEnable: boolean
  appBookingEnable: boolean
  webBookingEnable: boolean
}) => SBAPI.Put(`${VENUE_SEATING_AREAS_URL}/booking/visibility`, body)

export {
  attachSeatingAreas,
  fetchSevenroomsSeatingAreaForVenue,
  updateVenueSeatingAreaBookingVisibility,
}
